var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26148_79807)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 7.38527V7.99861C14.6659 9.43622 14.2004 10.8351 13.3396 11.9865C12.4788 13.1379 11.2689 13.9803 9.89028 14.3879C8.51166 14.7955 7.03821 14.7465 5.68969 14.2483C4.34116 13.7501 3.18981 12.8293 2.40735 11.6233C1.62488 10.4173 1.25323 8.99065 1.34783 7.55615C1.44242 6.12165 1.99818 4.75616 2.93223 3.66332C3.86628 2.57049 5.12856 1.80886 6.53083 1.49204C7.9331 1.17521 9.40022 1.32017 10.7134 1.90527",
    stroke: "#4CAF50",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 2.66797L8 9.3413L6 7.3413",
    stroke: "#4CAF50",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26148_79807"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.2ed8943ebea3d420ae23ea2cb356e9ea.svg";
export { ForwardRef as ReactComponent };